/** Constants and Enums **/

export const SelectedObjectType = {
    Building: 'building',
    SelectionBoxes: 'selectionBoxes',
    Route:'route',
    Plug: 'plug',
    Arrow: 'arrow',
    Cloth: 'cloth',
    Neighborhood: 'neighborhood'
}

export const ViewMode = {
    District: 'district',
    Orbit: 'orbit',
    Cylinder: 'cylinder',
    FloorPlan: 'floorplan'
}

export const EnvironmentTypes = {
  CesiumEnv: 'cesium',
  CesiumMultiEnv: 'cesium-multi',
  TilesEnv: 'tiles',
  GooglePhotorealistic: 'google-tiles',
  Ground: 'ground',
  Buildings: 'buildings',
  Trees: 'trees',
  BackHouses: 'backHouses',
}

export const CardTypes = {
  Unit: 'unit',
  Options: 'options',
  Amenities: 'amenities',
  Similar: 'similar',
  MobileCard: 'mobile'
}

export const FilterTypes = {
    Range: 'range'
}

export const PagesForPagination = {
    Gallery: 'gallery',
    Map: 'map',
    About : 'about',
    Model3D: '3dModel',
    Search: 'search',
    ContactUs: 'contactUs',
    Documents: 'documents',
    Specifications: 'specifications'
}
